export const MEDIA_BUCKET = "metworth-assets";
export const MAX_MEDIA_BYTES = 5 * 1024 * 1024;

export const MEDIA = {
  photo: {
    column: "profile_photo_url",
    folder: "profile-photo",
    label: "Profile photo",
    hint: "A clear, well-lit headshot works best.",
    types: ["image/jpeg", "image/png", "image/webp"],
    typesLabel: "JPG, PNG or WebP",
  },
  logo: {
    column: "company_logo_url",
    folder: "company-logo",
    label: "Company logo",
    hint: "Transparent PNG or SVG looks sharpest.",
    types: ["image/jpeg", "image/png", "image/webp", "image/svg+xml"],
    typesLabel: "JPG, PNG, WebP or SVG",
  },
};

export const MEDIA_EXT = { "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp", "image/svg+xml": "svg" };
